import React from "react";
import { Navigate } from "react-router-dom";

    function ProtectedRoute({ children }) {
        
        const authed = localStorage.getItem("cubix_order_taking_isAuthenticated") 
        return JSON.parse(authed) ? children : <Navigate to="/login" />;
    }

  export default ProtectedRoute;